import { getErrorMessage } from "@/helpers/handleErrorResponse";
import { ActiveSubscriptionResponse } from "@/types/subscriptions";
import { CustomError } from "@/utils/errors";

import axiosInstance from "../config";

export const getSubscriptionsDataQuota = async () => {
  try {
    const response = await axiosInstance.get("/v1/subscriptions/data-quota");
    return response.data;
  } catch (error) {
    const { status, message } = getErrorMessage(error);
    const newError = new CustomError(message, status);
    throw newError;
  }
};

export const getActiveSubscription = async () => {
  try {
    const response = await axiosInstance.get<ActiveSubscriptionResponse>(
      "/v1/active-subscription"
    );
    return response.data;
  } catch (error) {
    const { status, message } = getErrorMessage(error);
    const newError = new CustomError(message, status);
    throw newError;
  }
};
